/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Hangry::Application.
 * @version 420805a430c7c4279c8581ebedd52cc7eb7928ced1f4bcfac1a3b18c0600682c
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/drivers/:id/add(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addAdminDispatchDashboardDriverPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"drivers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addressesAdminDenyListEntriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBillingContactPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBillingContactsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/chats/:view(.:format)
 * @param {any} view
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChatPath = /*#__PURE__*/ __route({"view":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chat/auth_key(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChatAuthKeyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"auth_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chat/conversations/:view/:id(.:format)
 * @param {any} view
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChatConversationPath = /*#__PURE__*/ __route({"view":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"view"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chat/user_metadata/:user_type/:user_uuid(.:format)
 * @param {any} userType
 * @param {any} userUuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChatUserMetadataPath = /*#__PURE__*/ __route({"user_type":{"r":true},"user_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"user_metadata"],[2,[7,"/"],[2,[3,"user_type"],[2,[7,"/"],[2,[3,"user_uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCustomerSubscriptionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/deliveries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDeliveriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDenyListEntriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDenyListEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/cancel_autogrouping(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardCancelAutogroupingPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"cancel_autogrouping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch/:dispatch_id/dashboard_snapshots/:id(.:format)
 * @param {any} dispatchId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardSnapshotPath = /*#__PURE__*/ __route({"dispatch_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[3,"dispatch_id"],[2,[7,"/"],[2,[6,"dashboard_snapshots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch/:dispatch_id/dashboard_snapshots(.:format)
 * @param {any} dispatchId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardSnapshotsPath = /*#__PURE__*/ __route({"dispatch_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch"],[2,[7,"/"],[2,[3,"dispatch_id"],[2,[7,"/"],[2,[6,"dashboard_snapshots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/stores(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardStoresPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"stores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/trigger_autogrouping(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardTriggerAutogroupingPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"trigger_autogrouping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/update_panic(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDispatchDashboardUpdatePanicPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"update_panic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/drivers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDriverPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"drivers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDriverShiftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDriverShiftsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_blocks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMapBlockPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_blocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMapBlocksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_places/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMapPlacePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_places"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_places(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMapPlacesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_places"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrderNotePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrdersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stores/:store_id/pickup_points(.:format)
 * @param {any} storeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminStorePickupPointsPath = /*#__PURE__*/ __route({"store_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"store_id"],[2,[7,"/"],[2,[6,"pickup_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/suburbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSuburbsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"suburbs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/allocate(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allocateAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"allocate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/allocate(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allocateAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"allocate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/associate_driver(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associateDriverAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_driver"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/cancelled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelledAdminOrdersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"cancelled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mates_rates/change_payment_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePaymentMethodCustomerSubscriptionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mates_rates"],[2,[7,"/"],[2,[6,"change_payment_method"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatContextPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chat_context"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/compact(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compactAdminDispatchDashboardGroupsPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"compact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/:order_id/confirm_for_payment(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmForPaymentCheckoutPath = /*#__PURE__*/ __route({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"confirm_for_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gift_vouchers/:id/confirm_for_payment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmForPaymentGiftVoucherPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gift_vouchers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_for_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactsAdminDenyListEntriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/accounts/create_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAccountUsersAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"create_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_coupon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCouponAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_coupon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_delivery_booking_account_charge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeliveryBookingAccountChargeAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_delivery_booking_account_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/drivers/:id/create_note(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteAdminDispatchDashboardDriverPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"drivers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/stores/:id/create_note(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteAdminDispatchDashboardStorePath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRefundAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_refund_from_items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRefundFromItemsAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_refund_from_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/create_remake(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRemakeAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_remake"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mates_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSubscriptionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mates_rates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/customer_subscriptions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSubscriptionsAdminUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"customer_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mates_rates/cancel_subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSubscriptionsCancelSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mates_rates"],[2,[7,"/"],[2,[6,"cancel_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mates_rates/resume_subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSubscriptionsResumeSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mates_rates"],[2,[7,"/"],[2,[6,"resume_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/deallocate(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deallocateAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deallocate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/delay_prep(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delayPrepAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delay_prep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/download_packing_slip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadPackingSlipAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/drivers/:id/dropout(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropoutAdminDispatchDashboardDriverPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"drivers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dropout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBillingContactPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminDenyListEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminDriverShiftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminOrderNotePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stores/:store_id/pickup_points/:id/edit(.:format)
 * @param {any} storeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminStorePickupPointPath = /*#__PURE__*/ __route({"store_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"store_id"],[2,[7,"/"],[2,[6,"pickup_points"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/email_late_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailLateOrdersAdminOrdersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"email_late_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/expiring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expiringAdminDenyListEntriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[6,"expiring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_blocks/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const findAdminMapBlocksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_blocks"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/group(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_places/:id/import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAdminMapPlacePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_places"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/late(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lateAdminOrdersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"late"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/lock(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lockAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/accounts/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginUsersAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/merge(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDenyListEntryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDriverShiftPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_look/customers/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_look"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_look/confirm_for_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLookConfirmForPaymentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_look"],[2,[7,"/"],[2,[6,"confirm_for_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_look/review_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLookReviewOrderPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_look"],[2,[7,"/"],[2,[6,"review_order"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/order_chronologically(.:format)
 * @param {any} areaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderChronologicallyAdminDispatchDashboardGroupsPath = /*#__PURE__*/ __route({"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"order_chronologically"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/:reference(.:format)
 * @param {any} id
 * @param {any} reference
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orderDocketAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"reference":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"reference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts/:id/quick_confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickConfirmAdminDriverShiftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quick_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/drivers/:id/remove(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAdminDispatchDashboardDriverPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"drivers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/remove_delivery_booking_account_charge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeDeliveryBookingAccountChargeAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_delivery_booking_account_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_notes/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveAdminOrderNotePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restaurantPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/orders/returned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const returnedAdminOrdersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"returned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /restaurants/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchRestaurantsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"restaurants"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/send_delay_message(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendDelayMessageAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_delay_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/saved_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSavedCardPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"saved_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/saved_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSavedCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"saved_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/driver_shifts/:id/soft_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const softDeleteAdminDriverShiftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"driver_shifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"soft_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /imagery/store_attachment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storeAttachmentImageryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imagery"],[2,[7,"/"],[2,[6,"store_attachment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:id/cart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storeCartPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:id/categories(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storeCategoriesPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:id/search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storeSearchPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storefronts/:storefront_id/favourites/store(.:format)
 * @param {any} storefrontId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storeStorefrontFavouritesPath = /*#__PURE__*/ __route({"storefront_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storefronts"],[2,[7,"/"],[2,[3,"storefront_id"],[2,[7,"/"],[2,[6,"favourites"],[2,[7,"/"],[2,[6,"store"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storefronts/:storefront_id/carts(.:format)
 * @param {any} storefrontId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storefrontCartsPath = /*#__PURE__*/ __route({"storefront_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storefronts"],[2,[7,"/"],[2,[3,"storefront_id"],[2,[7,"/"],[2,[6,"carts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /storefronts/:storefront_id/deals(.:format)
 * @param {any} storefrontId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storefrontDealsPath = /*#__PURE__*/ __route({"storefront_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storefronts"],[2,[7,"/"],[2,[3,"storefront_id"],[2,[7,"/"],[2,[6,"deals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /storefronts/past_stores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storefrontsPastStoresPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"storefronts"],[2,[7,"/"],[2,[6,"past_stores"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/map_blocks/suburbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suburbsAdminMapBlocksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"map_blocks"],[2,[7,"/"],[2,[6,"suburbs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_look/orders/:secure_token/success/confirm(.:format)
 * @param {any} secureToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const successConfirmNewLookOrderPath = /*#__PURE__*/ __route({"secure_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_look"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"secure_token"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_look/orders/:secure_token/success(.:format)
 * @param {any} secureToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const successNewLookOrderPath = /*#__PURE__*/ __route({"secure_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_look"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"secure_token"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deny_list_entries/:id/unblock(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblockAdminDenyListEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deny_list_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/ungroup(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ungroupAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ungroup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/ungroup(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ungroupAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ungroup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/groups/:id/unlock(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlockAdminDispatchDashboardGroupPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dispatch_dashboard/:area_id/deliveries/:id/update_dash_note(.:format)
 * @param {any} areaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDashNoteAdminDispatchDashboardDeliveryPath = /*#__PURE__*/ __route({"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dispatch_dashboard"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_dash_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/update_delivery_booking_account_charge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDeliveryBookingAccountChargeAdminOrderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_delivery_booking_account_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/areas/:id/update_dispatcher(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDispatcherAdminAreaPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_dispatcher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

